import { deleteInventoryCategory } from "../../api/inventoryService";

export const useDeleteInventoryCategory = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteInventoryCategory(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete inventory category:", error);
            throw error;
        }
    };

    return { remove };
};